<script setup lang="ts">

const props = defineProps({
    as : {
        type: [String, Object],
        default: 'button'
    },
    classes: {
        type: String,
        default: ''
    }
});

const btnClasses = [
    'items-center justify-center max-md:gap-x-4 md:gap-x-2',
    'rounded-4xl border-2',
    'border-custom-green-600 text-custom-green-600',
    'xl:py-7',
].join(' ');
</script>

<template>
    <component
        :is="props.as"
        :class="[btnClasses, props.classes]">

        <span>
            <slot/>
        </span>

        <img :src="asset('image/icons/header/arrow-right-icon.svg')"
             width="26" height="9"
             decoding="async" loading="lazy"
             alt="">
    </component>
</template>

<style scoped>

</style>
